import { render, staticRenderFns } from "./cart-list.vue?vue&type=template&id=548e9a15&scoped=true"
import script from "./cart-list.vue?vue&type=script&lang=js"
export * from "./cart-list.vue?vue&type=script&lang=js"
import style0 from "./cart-list.vue?vue&type=style&index=0&id=548e9a15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e9a15",
  null
  
)

export default component.exports